// src/components/Carousel.jsx
// Generic testimonial/content carousel

import React, { useEffect, useState } from "react";
import { palette } from "./theme";

export default function Carousel({ items, interval = 6000 }) {
  const [index, setIndex] = useState(0);

  // Auto-advance
  useEffect(() => {
    const id = setInterval(
      () => setIndex((i) => (i + 1) % items.length),
      interval
    );
    return () => clearInterval(id);
  }, [interval, items.length]);

  const go = (i) =>
    setIndex(((i % items.length) + items.length) % items.length);

  return (
    <div className="relative">
      {/* Card */}
      <div
        className="rounded-2xl p-8 mx-auto max-w-3xl bg-white shadow"
        style={{ border: `1px solid ${palette.railLine}` }}
      >
        <p
          className="text-lg md:text-xl"
          style={{ color: palette.sub, lineHeight: 1.6 }}
        >
          “{items[index].quote}”
        </p>
        <div className="mt-4 font-semibold" style={{ color: palette.ink }}>
          — {items[index].author}
        </div>
      </div>

      {/* Dots */}
      <div className="mt-5 flex items-center justify-center gap-2">
        {items.map((_, i) => (
          <button
            key={i}
            aria-label={`Go to slide ${i + 1}`}
            onClick={() => go(i)}
            className="h-2.5 w-2.5 rounded-full"
            style={{
              backgroundColor:
                i === index ? palette.gold : palette.railLine,
              outline: "none",
              border: 0,
            }}
          />
        ))}
      </div>
    </div>
  );
}
